import React from "react";

import { 
    Box, 
    Card, 
    CardContent, 
    Grid, 
    Typography, 
    Avatar, 
    Chip, 
    Tooltip,
    Stack,
    Divider,
    alpha
} from "@mui/material";
import Skeleton from "@mui/material/Skeleton";
import { green, grey, orange } from '@mui/material/colors';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import TimerIcon from '@mui/icons-material/Timer';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CallIcon from '@mui/icons-material/Call';
import moment from 'moment';

import Rating from '@mui/material/Rating';
import { i18n } from "../../translate/i18n";



export function RatingBox({ rating }) {
    const ratingTrunc = rating === null ? 0 : Math.trunc(rating);
    return <Rating
        defaultValue={ratingTrunc}
        max={3}
        readOnly
    />
}

export default function TableAttendantsStatus(props) {
    const { loading, attendants } = props



    function formatTime(minutes) {
        return moment().startOf('day').add(minutes, 'minutes').format('HH[h] mm[m]');
    }

    if (loading) {
        return (
            <Grid container spacing={3}>
                {Array.from(new Array(4)).map((_, i) => (
                    <Grid item xs={12} sm={6} md={3} key={i}>
                        <Skeleton variant="rectangular" height={220} sx={{ borderRadius: "16px" }} />
                    </Grid>
                ))}
            </Grid>
        );
    }

    return (
        <Grid container spacing={3}>
            {attendants.map((a, k) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={k}>
                    <Card
                        sx={{
                            height: "100%",
                            borderRadius: "16px",
                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
                            border: "1px solid",
                            borderColor: "divider",
                            transition: "all 0.3s ease",
                            "&:hover": {
                                transform: "translateY(-4px)",
                                boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
                            },
                        }}
                    >
                        <CardContent sx={{ p: 2.5 }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <Avatar
                                        sx={{
                                            bgcolor: a.online ? green[500] : grey[400],
                                            width: 44,
                                            height: 44,
                                            mr: 1.5,
                                            fontWeight: "bold"
                                        }}
                                    >
                                        {a.name.charAt(0).toUpperCase()}
                                    </Avatar>
                                    <Box sx={{ maxWidth: 140 }}>
                                        <Typography variant="subtitle1" fontWeight="bold" noWrap title={a.name}>
                                            {a.name}
                                        </Typography>
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            <Box
                                                sx={{
                                                    width: 8,
                                                    height: 8,
                                                    borderRadius: "50%",
                                                    bgcolor: a.online ? green[500] : grey[400],
                                                    mr: 1
                                                }}
                                            />
                                            <Typography variant="caption" color="textSecondary">
                                                {a.online ? "Online" : "Offline"}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                                <Box>
                                    <RatingBox rating={a.rating} />
                                </Box>
                            </Box>

                            <Divider sx={{ mb: 2 }} />

                            <Stack spacing={1.5}>
                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        <CallIcon sx={{ fontSize: 18, color: "primary.main" }} />
                                        <Typography variant="body2" color="textSecondary">Chamadas</Typography>
                                    </Box>
                                    <Typography variant="body2" fontWeight="bold">{a.tickets}</Typography>
                                </Box>

                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        <AssessmentIcon sx={{ fontSize: 18, color: "orange" }} />
                                        <Typography variant="body2" color="textSecondary">Avaliações</Typography>
                                    </Box>
                                    <Typography variant="body2" fontWeight="bold">{a.countRating}</Typography>
                                </Box>

                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        <TimerIcon sx={{ fontSize: 18, color: grey[600] }} />
                                        <Typography variant="body2" color="textSecondary">T. Espera</Typography>
                                    </Box>
                                    <Typography variant="body2" fontWeight="bold">{formatTime(a.avgWaitTime)}</Typography>
                                </Box>

                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        <TimerIcon sx={{ fontSize: 18, color: grey[600] }} />
                                        <Typography variant="body2" color="textSecondary">T. Médio</Typography>
                                    </Box>
                                    <Typography variant="body2" fontWeight="bold">{formatTime(a.avgSupportTime)}</Typography>
                                </Box>
                            </Stack>
                        </CardContent>
                    </Card>
                </Grid>
            ))}
        </Grid>
    )
}